const CircleCheckIcon = (props: any) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.4351 9.85449L11.1412 14.1483L8.56494 11.572'
      stroke='#1FA238'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <circle cx='12' cy='12' r='9.25' stroke='#1FA238' strokeWidth='1.5' />
  </svg>
);

export default CircleCheckIcon;
